<template>
    <div class="user_all">
        <div class="user_search">
            <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
            <el-select
                    style="width: 220px"
                    v-model="selectValue"
                    @change="changeRpc()"
                    :placeholder="this.$t('title.RPC_service')"
            >
                <el-option
                        v-for="item in options"
                        :key="item.rpcUrl"
                        :label="item.name"
                        :value="item.rpcUrl"
                ></el-option>
            </el-select>
            <el-select
                    style="margin-left: 5%;width: 220px"
                    v-model="selectChain"
                    @change="changeChain()"
                    :placeholder="$t('title.Please_select_the_chain')"
            >
                <el-option
                        v-for="item in options1"
                        :key="item"
                        :label="item+$t('title.chain')"
                        :value="item"
                ></el-option>
            </el-select>
            <!--            <el-button type="primary" style="margin-left: 5%" @click="searchRpc()" :loading=isResponse>查询</el-button>-->
        </div>
        <div class="user_search" style="display: flex">
            <span style="width: 100px;display: inline-block">{{ $t('title.address') }}：</span>
            <el-input v-model="inputValue" type="primary" style="width: 380px" :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
            <el-button type="primary" style="margin-left: 5%" @click="searchBalance()" :loading=isResponse>{{ $t('title.Check_balances') }}
            </el-button>
            <el-button type="primary" style="margin-left: 5%" @click="searchHistory()" :loading=isResponse>{{ $t('title.search_history') }}
            </el-button>
        </div>
        <div class="con_table">
            <el-table
                    :data="tableData"
                    border
                    height="520"
                    style="width: 100%;margin-bottom: 30px;margin-top: 40px"
                    :header-cell-style="this.tableHeaderColor"
            >
                <el-table-column
                        :label="this.$t('title.Serial_number')"
                        align="center"
                        fixed
                        width="90">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.RPC_service')"
                        width="250"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.rpcServer}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Chain_id')"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromChainId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.address')"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAddress}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Balance')"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAfterCoins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="nonce"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.nonce}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Creation_time')"
                        fixed="right"
                        width="200"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{timestampToTime(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    @current-change="currentPageChange"
                    :current-page="currentPage"
                    :page-size="pagesize"
                    layout="total,prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import {getrpcserver, getchaininfo, transferList, getaccount} from '../../../api/interface'

    export default {
        name: 'AccountQuery',
        components: {},
        data() {
            return {
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                total: 0,
                isResponse: false,
                selectValue: "",
                options: '',
                selectChain: '',
                options1: '',
                inputValue: '',
                searchValue: ''
            }
        },
        methods: {
            changeRpc() {
                let data = {rpcServer: this.selectValue}
                getchaininfo(data).then(response => {
                    this.options1 = response.data
                    this.selectChain = this.options1[0]
                })
            },
            changeChain() {

            },
            getData() {
                getrpcserver().then(response => {
                    this.options = response.data
                    this.selectValue = this.options[0].rpcUrl
                    let data = {rpcServer: this.options[0].rpcUrl}
                    getchaininfo(data).then(response => {
                        this.options1 = response.data
                        this.selectChain = this.options1[0]
                        let data = {
                            "rpcServer": this.selectValue,
                            "chainId": this.selectChain,
                            "address": "",
                            "page": 1,
                            "rows": 10
                        }
                    })
                })
            },
            searchBalance() {
                if (this.inputValue != '') {
                    this.currentPage = 1
                    this.isResponse = true
                    this.getBalanceData(this.inputValue, this.currentPage, 1)
                } else {
                    this.$message.error('The address for checking the balance operation cannot be empty!')
                }
            },
            searchHistory() {
                this.currentPage = 1
                this.isResponse = true
                this.getTableData(this.inputValue, this.currentPage, 1)


            },
            currentPageChange(e) {
                this.currentPage = e
                this.getTableData(this.searchValue, this.currentPage, 0)
            },
            getTableData(address, page, type) {
                let data = {
                    "type": 100,
                    'address': address,
                    "page": page,
                    "rows": 10
                }
                transferList(data).then(response => {
                    this.isResponse = false
                    if (response.code == 200) {

                        this.tableData = response.data.data
                        this.total = response.data.total
                        if (type == 1) {
                            this.searchValue = address
                        }

                    } else {
                        this.tableData = []
                        this.total = 0
                        this.$message.error(response.msg)
                    }

                })
            },
            getBalanceData(address, page, type) {
                let data = {
                    "rpcServer": this.selectValue,
                    "chainId": this.selectChain,
                    "address": address,
                }
                getaccount(data).then(response => {
                    this.isResponse = false
                    if (response.code == 200) {
                        let arr = []
                        arr.push(response.data)
                        this.tableData = arr
                        console.log("res",arr)
                        this.tableData[0].rpcServer = this.selectValue
                        this.tableData[0].fromChainId = this.selectChain
                        this.tableData[0].fromAddress = this.tableData[0].address
                        this.tableData[0].fromAfterCoins = this.tableData[0].balanceValue
                        this.total = 1
                        if (type == 1) {
                            this.searchValue = address
                        }

                    } else {
                        this.tableData = []
                        this.total = 0
                        this.$message.error(response.msg)
                    }

                })
            }
        },
        computed: {
            iconColor() {
                const {color1, color2} = this;

                if (color1 && color2) {
                    return [color1, color2];
                } else {
                    return [];
                }
            }
        },
        created() {
            this.getData()
           this.getTableData(this.searchValue, this.currentPage, 0)
        }

    }
</script>
<style scoped>
    .user_all {
        padding: 20px 30px;
    }

    .user_search {
        margin-bottom: 30px;
    }
</style>
